import { BaseStore } from "stores/base_store"
import { runInAction, makeAutoObservable } from "mobx"
import { api_get } from "api/utils"
export type SortableType = {
    key: string;
    uuid: string;
    identity: string;
    associated_type: string;
    associated_uuid: string;

    date_created: string;
    date_updated: string;
    updateProps?: (attributes: SortableType) => void;
};

// Domain object Sortable
export class Sortable implements SortableType {
    key = "";
    uuid = "";
    identity = "";

    associated_type = "";
    associated_uuid = "";

    date_created = "";
    date_updated = "";

    constructor(attributes: SortableType) {
        makeAutoObservable(this, {
            updateProps: false
        })
        if (attributes) {
            this.updateProps(attributes);
        }
    }

    updateProps(attributes: SortableType) {
        runInAction(() => {
            Object.assign(this, attributes);
        });
    }
}


export class SortableStore extends BaseStore<SortableType, Sortable> {

    async fetchSortable(uuid: string) {
        // Autogenerated
        const response = await api_get(`/sortable?uuid=${uuid}`);
        if(response.ok) {
            const data = await response.json();
            this.receiveUpdate(data);
            return data;
        }
        return null;
    }


    modelConstructor() {
        return Sortable;
    }

}
